// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__aoUXZ","header":"MergedInvoice_header__15cS7"};